<template>
  <v-avatar
    tile
    color="secondaryBackground"
    :class="`bordered-${borderSize}`"
    class="rounded-lg"
    :size="deviceSize.mobile ? size * 0.75 : size"
    style="transition: left 1s ease-in-out, top 1s ease-in-out"
  >
    <v-img
      v-if="imageSrc?.length"
      id="avatarImage"
      contain
      :src="imageSrc"
      alt="Logo"
    >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0 secondarySheet"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="loading"
            size="20"
            width="2"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <v-icon v-else-if="icon?.length" large color="icon" v-text="icon"></v-icon>
    <v-icon v-else small color="background5">mdi-image-off-outline</v-icon>
  </v-avatar>
</template>

<script>
// Libraries
import { mapGetters } from "vuex";
import {
  // Firestore
  firestore,
  collection,
  getDocs,
  where,
  query,
  getDoc,
  doc,
  onSnapshot,
  // Functions
  functions,
  httpsCallable,
  // Remote Config
  remoteConfig,
  getValue,
} from "@/firebase/init";
// Components
import moment from "moment-timezone";

export default {
  name: "BorderedAvatar",
  props: {
    icon: {
      default: "",
      type: String,
      required: false,
    },
    imageSrc: {
      default: "",
      type: String,
      required: false,
    },
    size: {
      default: 40,
      type: Number,
      required: false,
    },
    borderSize: {
      default: 2,
      type: Number,
      required: false,
    },
  },
  data: () => ({}),
};
</script>

<style></style>
